var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"store"},[_c('div',{staticClass:"page"},[_c('div',{staticClass:"page-content"},[_c('crumbsVue',{attrs:{"navs":_vm.navs}}),_vm._l((_vm.dataList),function(item,index){return _c('followedStoreItem',{key:index,staticClass:"mb20",attrs:{"item":item},on:{"cancelFollow":_vm.cancelFollow}})})],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }